import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=753be5fa&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=753be5fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753be5fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('753be5fa')) {
      api.createRecord('753be5fa', component.options)
    } else {
      api.reload('753be5fa', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=753be5fa&scoped=true&", function () {
      api.rerender('753be5fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26Y53V2d45JhP/JS/comp/SearchFilterTokens.vue"
export default component.exports